'use strict';

/* ************* name ***************

*******************************************/
angular.module('util.trsBigFaceModule', []).directive('trsBigFace', ['trsHttpService', '$filter', '$timeout', 'globleParamsSet', '$q',
    function(trsHttpService, $filter, $timeout, globleParamsSet, $q) {
        return {
            restrict: 'E',
            scope: {
                draftInfo: '=',
                switch: '=',
            },
            replace: true,
            templateUrl: './components/util/trsBigFace/trsBigFace_tpl.html',
            link: function(scope, $element, iAttrs) {
                init();

                /**
                 * [init description] 初始化数据
                 * @return {[type]} [description]
                 */
                function init() {
                    scope.status = {};
                    scope.data = {};
                    watchSwitch(function() {
                        scope.data.diffEditCost = 8;
                        openBigFace();
                    }, function() {
                        closeBigFace();
                    });
                }

                /**
                 * [openBigFace description] 开始渲染大花脸
                 * @return {[type]} [description]
                 */
                function openBigFace() {
                    if (!Number(scope.draftInfo.METADATAID)) {return;} // 如果没有METADATAID或者METADATAID为0则停止渲染
                    getMetaViewDataVersions().then(function(data) {
                        scope.data.versionData = data;
                        return loadBigFace();
                    }).then(function() {
                        textConversion(scope.data.versionData);
                        var orgDataArray = scope.data.versionData[0].CONTENT.split('\n');
                        scope.status.orgContent = orgDataArray.map(function(value, index, array) {
                            return value = '<span>' + value + '</span>';
                        }).join('<br/>');
                        // bindUserColorByCrtime(angular.copy(scope.data.versionData));
                        constructingData(scope.data.versionData);
                    });
                }

                /**
                 * [handleText description]处理文字
                 * @param   {[type]}  range  [range description]
                 * @return  {[type]}         [return description]
                 */
                scope.handleText = function(range) {
                    range.USERNUM = range.USERNUM || scope.data.crTimeObj[range.CRTIME];
                    if (range.type !== '=') {
                        range.htmlContent = [
                            range.fragment.replace(/\n/g, '<br/>').replace(/\u3000/g, "<span opertype='" + range.opertype + "' class='space-bg" + range.USERNUM + "'>\u3000</span>")
                        ].join('');
                    } else {
                        range.fragment = range.fragment.replace(/<(p)[^>]*>/ig, '');
                        range.htmlContent = [
                            range.fragment.replace(/\n/g, '<br/>')
                        ].join('');
                    }
                    // if (!range.opertype) {
                    //     range.opertype = range.type === '+' ? 'add' : (range.type === '-' ? 'sub' : 'org');
                    //     if (range.type !== '=') {
                    //         var titleWithoutOperType = range.TRUENAME + '，' + range.CRTIME;
                    //         range.title = titleWithoutOperType + '，' + (range.opertype === 'add' ? '新增' : '删除');
                    //         if (range.last && range.last === '1') {
                    //             range.title = range.TRUENAME_last + '，' + range.CRTIME_last + '新增；' + range.title;
                    //         }
                    //     }
                    // }
                };

                /**
                 * [toggleComparisonMode description] 切换比较模式
                 * @param   {[type]}  diffEditCost  [diffEditCost description] 比较模式标记
                 * @return  {[type]}                [return description]
                 */
                scope.toggleComparisonMode = function(diffEditCost) {
                    scope.data.diffEditCost = diffEditCost;
                    delete scope.data.selectedRange;
                    delete scope.data.selectedUser;
                    constructingData(scope.data.versionData);
                };

                /**
                 * [constructingData description] 这就开始构造大花脸数据
                 * @return {[type]} [description]
                 */
                function constructingData() {
                    scope.status.bigface = new trs.BigFace('CONTENT', scope.data.diffEditCost);
                    var results = scope.status.bigface.execute(scope.data.versionData);
                    if (results === undefined) { // 如果没有对比结果，则使用第一个作为初始文本
                        scope.data.userList = [{
                            userName: scope.data.versionData[0].TRUENAME,
                            userNum: 1,
                            userList: [{
                                TRUENAME: scope.data.versionData[0].TRUENAME,
                                CRTIME: new Date(Date.parse(scope.data.versionData[0].CRTIME)),
                                USERNUM: '1',
                                VERSIONNUM: '1',
                                opertype: 'org',
                                type: '=',
                            }],
                        }];
                        return;
                    }
                    var timeObj = {};
                    for (var i = 0; i < results.length; i++) { // 给修改痕迹相应的颜色，按照时间点给
                        var range = results[i];
                        timeObj[range.CRTIME] = true;
                        range.opertype = range.type === '+' ? 'add' : (range.type === '-' ? 'sub' : 'org');
                        // range.USERNUM = scope.data.crTimeObj[range.CRTIME];
                        if (range.type !== '=') {
                            var titleWithoutOperType = range.TRUENAME + '，' + range.CRTIME;
                            range.title = titleWithoutOperType + '，' + (range.opertype === 'add' ? '新增' : '删除');
                            if (range.last && range.last === '1') {
                                range.title = range.TRUENAME_last + '，' + range.CRTIME_last + '新增；' + range.title;
                            }
                        }
                    }
                    userListBycrtime(timeObj);
                    scope.data.results = results;
                    setTimeout(function() {
                        scope.data.copyResults = angular.copy(results); // 用来存储修改对比结果，后面选择时间点从里面过滤
                    });
                    // if (scope.status.selectedRange) { // 切换对比模式时，如果有选中版本，则进行过滤
                    //     showModificationTrace();
                    // }
                }

                /**
                 * [delete1 description] 先按照时间排序，再按照人物聚合
                 *
                 * @param   {[type]}  timeObj  [time description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function userListBycrtime(timeObj) {
                    scope.data.crTimeObj = {};
                    scope.data.userList = [];
                    var prevName = '';
                    var userNum = 1;
                    var obj = {};
                    scope.data.userList = [
                        {
                            userName: scope.data.versionData[0].TRUENAME,
                            userNum: 1,
                            userList: [scope.data.versionData[0]]
                        }
                    ];
                    for (var j = 1; j < scope.data.versionData.length; j++) {
                        if (timeObj[scope.data.versionData[j].CRTIME]) { // 如果某个版本没有进行修改，则不显示
                            var item = scope.data.versionData[j];
                            if (prevName !== item.TRUENAME) {
                                prevName = item.TRUENAME;
                                if (j !== 1) {
                                    if (obj.userNum) {
                                        scope.data.userList.unshift(obj);
                                    }
                                }
                                userNum++;
                                item.USERNUM = userNum;
                                obj = {
                                    userName: item.TRUENAME,
                                    userNum: userNum,
                                    userList: [item]
                                };
                            } else { // 将一个人连续修改的痕迹放在一起
                                item.USERNUM = userNum;
                                obj.userList.unshift(item);
                            }
                            scope.data.crTimeObj[item.CRTIME] = userNum;
                        }
                    }
                    if (obj.userNum) {
                        scope.data.userList.unshift(obj);
                    }
                }

                /**
                 * [textConversion description] 正文显示处理
                 * @param  {[type]} data [description]
                 * @return {[type]}      [description]
                 */
                function textConversion(data) {
                    for (var i = 0; i < data.length; i++) {
                        var centerSpace = titleCenter();
                        var content = angular.isUndefined(data[i].HTMLCONTENT) ? data[i].CONTENT : data[i].HTMLCONTENT; // 兼容了飞腾回写不返回HTMLCONTENT的情况
                        data[i].CONTENT = globleParamsSet.getBigFaceContent('<p>' + centerSpace + data[i].TITLE + '</p><p>　</p><p>' + content + '</p>');
                        data[i].CONTENT = '<p>' + data[i].CONTENT + '</p>'; // 加个p标签解决一些问题
                    }
                }

                /**
                 * [titleCenter description] 标题居中
                 * @return {[type]} [description]
                 */
                function titleCenter() {
                    var space = '　';
                    for (var i = 0; i < 5; i++) {
                        space += '　';
                    }
                    return space;
                }

                /**
                 * [getMetaViewDataVersions description] 获取稿件的历史文字版本
                 * @return {[type]} [description]
                 */
                function getMetaViewDataVersions() {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_extversion',
                        methodname: 'getMetaViewDataVersions',
                        MetaDataId: scope.draftInfo.METADATAID,
                    };
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                        .then(function(data) {
                            if (!data || data.length === 0) {
                                scope.status.noData = true;
                                return;
                            }
                            // var prevName = data[0].TRUENAME;
                            // 前几个版本都是同一个人时，则只显示这个人的最后一个版本，并且将版本号重新排列
                            // for (var i = 1; i < data.length; i++) {
                            // if (prevName !== data[i].TRUENAME) {
                            //     prevName = '';
                            //     data[i].VERSIONNUM = i + 1 + '';
                            // } else {
                            //     data[i].VERSIONNUM = i + '';
                            //     data.splice(i - 1, 1);
                            //     i--;
                            // }
                            // }
                            deffer.resolve(data);
                        });
                    return deffer.promise;
                }

                /**
                 * [loadBigFace description] 加载大花脸源码
                 * @return {[type]} [description]
                 */
                function loadBigFace() {
                    var deffer = $q.defer();
                    LazyLoad.js(['./lib/bigface/diff_match_patch.js?v9.0'], function() {
                        LazyLoad.js(['./lib/bigface/bigface.js?v9.0'], function() {
                            LazyLoad.css(['./lib/bigface/bigface.css?v9.0'], function() {
                                deffer.resolve();
                            });
                        });
                    });
                    return deffer.promise;
                }

                /**
                 * [closeBigFace description] 关闭大花脸
                 * @return {[type]} [description]
                 */
                function closeBigFace() {
                    scope.status = {};
                    scope.data = {};
                }

                /**
                 * [watchSwitch description] 渲染开关
                 * @param  {[type]} open  [description]
                 * @param  {[type]} close [description]
                 * @return {[type]}       [description]
                 */
                function watchSwitch(open, close) {
                    scope.$watch('switch.status', function(newV, oldV) {
                        if (newV) {
                            open();
                        } else {
                            close();
                        }
                    });
                }

                /**
                 * [selectUser description]选择指定用户，默认选中其最近的一个版本，隐藏与其无关的删除痕迹，其它版本的添加痕迹变黑。相当于与最终版本对比
                 *
                 * @param   {[type]}  user   [user description]
                 * @param   {[type]}  index  [index description]
                 *
                 * @return  {[type]}         [return description]
                 */
                scope.selectUser = function(user) {
                    scope.status.showOrg = false;
                    delete scope.status.selectedRange;
                    if (scope.status.selectedUser && scope.status.selectedUser.userNum === user.userNum) {
                        delete scope.status.selectedUser;
                        scope.data.results = angular.copy(scope.data.copyResults);
                        return;
                    }
                    // scope.status.selectedRange = user.userList[0];
                    scope.status.selectedUser = user;
                    if (user.userNum === 1) {
                        scope.status.showOrg = true;
                        return;
                    }
                    showModificationTrace(true);
                };

                /**
                 * [selectRange description]选择日期，隐藏与其无关的删除痕迹，其它版本的添加痕迹变黑。相当于与最终版本对比
                 *
                 * @param   {[type]}  result  [result description]
                 * @param   {[type]}  item    [item description]
                 *
                 * @return  {[type]}          [return description]
                 */
                scope.selectRange = function(result, item) {
                    scope.status.showOrg = false;
                    if (scope.status.selectedRange && scope.status.selectedRange === item) {
                        delete scope.status.selectedUser;
                        delete scope.status.selectedRange;
                        scope.data.results = angular.copy(scope.data.copyResults);
                        return;
                    }
                    scope.status.selectedUser = result;
                    scope.status.selectedRange = item;
                    if (result.userNum === 1) {
                        scope.status.showOrg = true;
                        return;
                    }
                    showModificationTrace(false);
                };

                /**
                 * [showModificationTrace description]展示选中人的时间点修改痕迹
                 *
                 * @param   {[type]}  flag  [flag description] 代表是点人还是点时间，点时间的话只显示一个版本，点人的话则没有时间的概念
                 *
                 * @return  {[type]}        [return description]
                 */
                function showModificationTrace(flag) {
                    scope.data.results = [];
                    scope.data.copyResults.forEach(function(result) {
                        var obj = angular.copy(result);
                        var isOtherUser = flag ? result.TRUENAME !== scope.status.selectedUser.userName : result.CRTIME !== scope.status.selectedRange.CRTIME;
                        if (isOtherUser) {
                            if (result.opertype !== 'sub') {
                                obj.USERNUM = 1;
                                scope.data.results.push(obj);
                            } else {
                                if ((result.TRUENAME_last === scope.status.selectedUser.userName && flag) || (scope.status.selectedRange && result.CRTIME_last === scope.status.selectedRange.CRTIME && !flag)) {
                                    scope.data.results.push(obj);
                                }
                            }
                        } else {
                            scope.data.results.push(obj);
                        }
                    });
                    // scope.data.results = results;
                }

                /**
                 * [time description] 整理时间格式
                 *
                 * @param   {[type]}  CRTIME  [CRTIME description]
                 *
                 * @return  {[type]}          [return description]
                 */
                scope.time = function(CRTIME) {
                    return new Date(Date.parse(CRTIME));
                };
            },
        };
    }
]);
